import { render, staticRenderFns } from "./CardColumna.vue?vue&type=template&id=68dba3d9&"
import script from "./CardColumna.vue?vue&type=script&lang=js&"
export * from "./CardColumna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports